<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1">
</a><a id="page_2">
</a><a id="page_4">
</a><h1 class="title"><a id="page_4"></a><a id="page_5">Reasons</a></h1><a id="page_5">
<h1 class="title1"><em class="italic">to</em></h1>
<h1 class="title2">Live</h1>
<p class="subtitle">An Interactive Guide to Healing and Overcoming Suicidal Thoughts and How to Help Others Survive</p>
<p class="author">Juliana J Bruno, a.k.a. Juliana Jay</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?609364d6